import * as React from 'react';
import { IconChevronLeft16, IconButton, ModalFullscreen, UIHeading4 } from '@cian/ui-kit';
import * as styles from './Modal.css';
import { HEADER_HEIGHT } from './constants';
import { useHeightController } from './hooks';
import { useEventCallback } from '@cian/react-utils';

export interface IModalProps {
  open: boolean;
  title?: string;
  footer?: React.ReactNode;
  name?: string;
  onClose?(): void;
}

export const Modal: React.FC<React.PropsWithChildren<IModalProps>> = ({
  children,
  open,
  title,
  footer,
  name,
  onClose,
}) => {
  const { footerRef, footerHeight } = useHeightController({ open });
  /* istanbul ignore next */
  const handleClose = useEventCallback(() => {
    if (onClose) {
      onClose();
    }
  });

  return (
    <ModalFullscreen theme="white" open={open} onClose={handleClose}>
      <div className={styles['container']} data-name={name}>
        <div className={styles['header']} style={{ height: HEADER_HEIGHT }}>
          <div onClick={onClose} className={styles['back-button']}>
            <IconButton icon={<IconChevronLeft16 display="block" />} aria-label="Назад" />
          </div>
          {title && (
            <div className={styles['title']}>
              <UIHeading4>{title}</UIHeading4>
            </div>
          )}
        </div>
        <div className={styles['content']} style={{ paddingTop: HEADER_HEIGHT, paddingBottom: footerHeight }}>
          {children}
        </div>
        {footer && (
          <div className={styles['footer']} ref={footerRef}>
            {footer}
          </div>
        )}
      </div>
    </ModalFullscreen>
  );
};
